import { useCallback } from 'react';

import { usePermissions } from '../../modules/iam/permissions-context.js';
import { missingPermissionTooltip } from './missing-permission-tooltip.js';

/** Returns a tooltip builder naming which of the given permissions the caller lacks (all of them when it holds every one). */
export function useDeniedTooltip(): (...permissions: [string, ...string[]]) => string {
  const { permissions: held, roleNames, grantingRoles } = usePermissions();
  return useCallback(
    (...permissions: [string, ...string[]]) => {
      const [first, ...rest] = permissions.filter((permission) => !held.includes(permission));
      const named: [string, ...string[]] = first === undefined ? permissions : [first, ...rest];
      return missingPermissionTooltip(named, { roleNames, grantingRoles });
    },
    [held, roleNames, grantingRoles],
  );
}
